import React, { forwardRef } from 'react';
import { styled } from '@mui/material/styles';

const ExtraInfoRoot = styled('div')(({ theme }) => ({
  width: 280,
  borderLeft: `1px solid ${theme.palette.divider}`
}));

const ExtraInfo = ({ children, ...rest }, ref) => {
  return (
    <ExtraInfoRoot ref={ref} {...rest}>
      {children}
    </ExtraInfoRoot>
  );
};

export default forwardRef(ExtraInfo);
